module.exports = __webpack_public_path__ + "static/media/arteplastic@2x.00719141.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/arteplastic@2x.png
// module id = 79
// module chunks = 0